import { THEME_MODE, THEME_STORAGE_KEY, ThemeMode } from './constants';

const MODES: string[] = Object.values(THEME_MODE);

const isThemeMode = (value: string | null): value is ThemeMode =>
  value !== null && MODES.includes(value);

// Storage can be missing or throw (private windows, blocked site data), and the theme must still
// work for the session, so every access falls back instead of surfacing.
export const readStoredMode = (): ThemeMode => {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);

    return isThemeMode(stored) ? stored : THEME_MODE.SYSTEM;
  } catch {
    return THEME_MODE.SYSTEM;
  }
};

export const storeMode = (mode: ThemeMode) => {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, mode);
  } catch {
    // Nothing to do: the choice just won't survive a reload.
  }
};

// Another tab of the site changed the choice. The browser reports it here only for OTHER tabs, so
// this never echoes our own write. A `null` key means the whole storage was cleared.
export const subscribeToStoredMode = (onChange: (mode: ThemeMode) => void) => {
  const handleStorage = (event: StorageEvent) => {
    if (event.key === null || event.key === THEME_STORAGE_KEY) {
      onChange(readStoredMode());
    }
  };

  window.addEventListener('storage', handleStorage);

  return () => window.removeEventListener('storage', handleStorage);
};
